import React from 'react';
import {
   Box,
   Button,
   Card,
   TextField,
   TextareaAutosize,
   Typography,
} from '@mui/material';
import backImg from '../../assets/back.svg';
import twitter from '../../assets/twitter.svg';
import linkedin from '../../assets/linkedin.svg';
import facebook from '../../assets/facebook.svg';
import instagram from '../../assets/instagram.svg';
import styled from '@emotion/styled';
import { Formik } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
import { getBaseUrls } from '../../components/app/features/env';
import { toast } from 'react-toastify';
import { SiTiktok } from 'react-icons/si';

export const Container = styled(Box)(
   ({ theme }) => `
 padding:  ${theme.header.height} 0 2rem 0; 
 min-height: 100vh; 
 background: #f8f8f8;
 `
);

export const userLSAuth = () => {
   if (localStorage.getItem('userAuth')) {
      const authData = localStorage.getItem('userAuth');
      const userAuth = authData == 'undefined' ? {} : JSON.parse(authData);
      return userAuth;
   } else {
      return null;
   }
};

const TextInput = styled(TextField)(
   ({ theme }) => `
       background: white;
       color: #49454F;
       &.placeholer{
        color: red;
       }
     `
);

const DescBox = styled(TextareaAutosize)(
   ({ theme }) => `
       background: white;
       color: #2E2C21;
       width:100%;
       margin-top: 5px;
       border:1px solid #E5E5E5;
       min-height:150px;
       padding:15px;
       border-radius:5px ;
							font-size: 1rem;
       &.placeholer{
        color: red;
       }
       &:focus{

        outline: 1px solid #374DA0;
       }
     `
);

export const FlatButton = styled(Button)(
   ({ theme }) => `
background: #0040BF;
color: #fff;
font-weight: 500;
width: 50%;
text-align: center;
font-size: 0.9rem;
border-radius:10px;
margin: 1rem auto;
cursor: pointer;

&:hover {background: #374DA0;}
`
);

const Contact = () => {
   const contactSupport = async (payload) => {
      try {
         const response = axios.post(
            `${getBaseUrls().data}/v1/feature/contact-us`,
            payload
         );
         if (response) toast.success('message sent successfully');
      } catch (error) {
         console.log(error);
      }
   };

   return (
      <Container>
         <Card
            sx={{
               width: '90%',
               maxWidth: '615px',
               minHeight: '80vh',
               margin: '0 auto',
               marginTop: '2rem',
               position: 'relative',
               boxShadow:
                  '0px 1px 2px rgba(0, 0, 0, 0.3), 0px 2px 6px 2px rgba(0, 0, 0, 0.15)',
               padding: '20px ',
               background: 'white',
               borderRadius:'#2E2C21'
            }}
         >
            <Box
               sx={{
                  margin: '0 auto',
                  marginTop: '1rem',
                  border: '1px solid transparent',
                  position: 'relative',
               }}
            >
               <img
                  src={backImg}
                  alt="back"
                  style={{
                     position: 'absolute',
                     width: '40px',
                     cursor: 'pointer',
                  }}
                  onClick={() => window.history.back()}
               />
                <Typography
                  sx={{
                     textAlign: 'center',
                     fontSize:{ xs: '2rem', sm:'2.5rem',md:'2.5rem'} ,
                     fontWeight: '600',
                    
                     color:'#2E2C21',
                  }}
                  className='font-cormorant'
               >
                  Contact us
               </Typography>
               <Typography
                  sx={{
                     // width: 'max-content',
                     fontWeight: 500,
                     fontSize: '1rem',
                     color: '#2E2C21',
                 
                     textAlign: 'center',
                     mt: 1,
                  }}
               >
                  Feel free to reach out to us through our social handles or by
                  filling out the Contact form below. We value your feedback and
                  look forward to serving you!
               </Typography>
               <Typography
                  sx={{
                     mb: 4,
                     mt:2,
                     width: '150px',
                     mx: 'auto',
                     display: 'flex',
                     justifyContent: 'space-between',
                  }}
               >
                  <a
                     href="https://www.linkedin.com/in/parrotica-ng-aa8779289?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
                     target="_blank"
                  >
                     <img
                        style={{
                           width: '30px',
                        }}
                        src={linkedin}
                        alt="icon"
                     />
                  </a>
                  <a
  href="https://www.tiktok.com/@parrotica_ng"
  target="_blank"
  rel="noopener noreferrer"
>
  <Box
    sx={{
      backgroundColor: "#374da0", 
      borderRadius: "50%",
      width: 30,
      height: 30,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transition: "0.3s",
     
    }}
  >
    <SiTiktok size={20} color="#fff" />
  </Box>
</a>

                 
                  <a href="https://twitter.com/parrotica" target="_blank">
                     <img
                        style={{
                           width: '30px',
                        }}
                        src={twitter}
                        alt="icon"
                     />
                  </a>
                  <a
                     href="https://www.facebook.com/profile.php?id=100084230776114&mibextid=9R9pXO"
                     target="_blank"
                  >
                     <img
                        style={{
                           width: '30px',
                        }}
                        src={facebook}
                        alt="icon"
                     />
                  </a>
               </Typography>
               <Formik
                  initialValues={{
                     email: '',
                     feature: '',
                     desc: '',
                     phone:'',
                  }}
                  validationSchema={Yup.object().shape({
                     email: Yup.string().required('Please enter your email'),
                     feature: Yup.string().required(
                        'Please enter Feature Name'
                     ),
                     desc: Yup.string()
                        .label('desc')
                        .required('Please enter description'),

                        phone: Yup.string()
                        .matches(/^[\+]?[(]?[0-9]{1,4}[)]?[-\s\.]?[0-9]{1,4}[-\s\.]?[0-9]{1,9}$/, 
      'Please enter a valid phone number')
                        .max(25, 'Invalid Phone number')
                        .required('Please enter your phone number'),
                        
                       
                  })}
                  onSubmit={async (values, { setSubmitting, resetForm }) => {
                     contactSupport({
                        name: userLSAuth().fullName,
                        email: values.email,
                        phone:values.phone,
                        message: `${values.feature}: ${values.desc}`,
                     });
                     setTimeout(() => {
                        resetForm();
                        setSubmitting(false);
                     }, 400);
                  }}
               >
                  {({
                     errors,
                     handleBlur,
                     handleChange,
                     handleSubmit,
                     isSubmitting,
                     touched,
                     values,
                     setFieldValue,
                  }) => (
                     <form
                        onSubmit={handleSubmit}
                        noValidate
                        style={{
                           marginTop: '2rem',
                        }}
                     >
                        <Typography
                           sx={{
                              lineHeight: 1,
                              fontWeight: 400,
                            
                              fontSize: '0.9rem',
                              mb: '5px',
                              color:'#2E2C21'
                           }}
                        >
                           Email
                        </Typography>
                        
                        <TextInput
                           // error={Boolean(touched.name && errors.name)}
                           fullWidth
                           margin="normal"
                           name="email"
                           placeholder="Enter your email"
                           onBlur={handleBlur}
                           onChange={handleChange}
                           type="email"
                           value={values.email}
                           variant="outlined"

                           sx={{
                              "& .MuiOutlinedInput-root": {
                                "& fieldset": {
                                  borderColor: "#E5E5E5", 
                                },
                                "&:hover fieldset": {
                                  borderColor: "#E5E5E5", 
                                },
                                "&.Mui-focused fieldset": {
                                  borderColor: "#E5E5E5", 
                                },
                              },
                            }}
                        
                        />
                        <span
                           style={{
                              color: 'red',
                           
                           }}
                        >
                           {errors.email && touched.email && errors.email}
                        </span>

                        <Typography
                          sx={{
                           lineHeight: 1,
                           fontWeight: 400,
                           
                           fontSize: '0.9rem',
                           mb: '5px',
                           color:'#2E2C21',
                           mt:2
                        }}
                        >
                           Phone
                        </Typography>


                        <TextInput
						 fullWidth
                   margin="normal"
                   name="phone"
                   placeholder="Enter your phone number"
                   onBlur={handleBlur}
                   onChange={handleChange}
                   type="tel"
                   value={values.phone}
                   variant="outlined"
                   sx={{
                     "& .MuiOutlinedInput-root": {
                       "& fieldset": {
                         borderColor: "#E5E5E5", 
                       },
                       "&:hover fieldset": {
                         borderColor: "#E5E5E5", 
                       },
                       "&.Mui-focused fieldset": {
                         borderColor: "#E5E5E5", 
                       },
                     },
                   }}
						
						/> 
                   <span
                           style={{
                              color: 'red',
                             
                           }}
                        >
                           {errors.phone && touched.phone && errors.phone}
                        </span>





                        <Typography
                            sx={{
                              lineHeight: 1,
                              fontWeight: 400,
                              
                              fontSize: '0.9rem',
                              mb: '5px',
                              color:'#2E2C21',
                              mt:2
                           }}
                        >
                           Subject
                        </Typography>
                        <TextInput
                           fullWidth
                           margin="normal"
                           name="feature"
                           placeholder="Enter Subject Title"
                           error={Boolean(touched.feature && errors.feature)}
                           onBlur={handleBlur}
                           onChange={handleChange}
                           type={'text'}
                           value={values.feature}
                           variant="outlined"
                           sx={{
                              "& .MuiOutlinedInput-root": {
                                "& fieldset": {
                                  borderColor: "#E5E5E5", 
                                },
                                "&:hover fieldset": {
                                  borderColor: "#E5E5E5", 
                                },
                                "&.Mui-focused fieldset": {
                                  borderColor: "#E5E5E5", 
                                },
                              },
                            }}
                        />
                        <span
                           style={{
                              color: 'red',
                            
                           }}
                        >
                           {errors.feature && touched.feature && errors.feature}
                        </span>
                        <Typography
                           sx={{
                              lineHeight: 1,
                              fontWeight: 400,
                              
                              fontSize: '0.9rem',
                              mb: '5px',
                              color:'#2E2C21',
                              mt:2
                           }}
                        >
                           Description
                        </Typography>
                        <DescBox
                           name="desc"
                           placeholder="Enter description"
                           // error={Boolean(touched.desc && errors.desc)}
                           onBlur={handleBlur}
                           onChange={handleChange}
                           value={values.desc}
                           variant="outlined"
                           sx={{
                              "& .MuiOutlinedInput-root": {
                                "& fieldset": {
                                  borderColor: "#E5E5E5", 
                                },
                                "&:hover fieldset": {
                                  borderColor: "#E5E5E5", 
                                },
                                "&.Mui-focused fieldset": {
                                  borderColor: "#E5E5E5", 
                                },
                              },
                            }}
                        />
                        <span
                           style={{
                              color: 'red',
                            
                           }}
                        >
                           {errors.desc && touched.desc}
                        </span>
                        <Box display={'flex'} sx={{ marginTop: '1rem' }}>
                           <FlatButton
                              disabled={
                                 !values.email ||
                                 !values.feature ||
                                 !values.desc ||
                                 !values.phone
                              }
                              type="submit"
                           >
                              Send
                           </FlatButton>
                        </Box>
                     </form>
                  )}
               </Formik>
            </Box>
         </Card>
      </Container>
   );
};

export default Contact;
